export enum ClaimEventsTarget {
  Auto = 'Auto',
  OORR = 'OORR'
}
